import {httpAction, getAction, postAction} from '@/api/manage'
//驳回
export function reject(applicationCode,that){
  if(applicationCode === 'env_audit'){
    epm_reject(that);
  }else if(applicationCode === 'ipsys'){
    ipsys_reject(that);
  }else if(applicationCode === 'cst'){
    cst_reject(that)
  }else{
    other_reject(that,applicationCode);
  }
}
function other_reject(that,applicationCode){
  let map = {};
  map.applicationCode=applicationCode;
  map.processGuid = that.model.process_guid;
  map.taskCode = that.model.task_code;
  map.approverUserCode = that.$store.getters.userInfo.workNo;
  map.comments = that.model.comments;
  map.approveAction = "Reject";
  map.fileList = that.model.filelist;
  if(map.comments===null||map.comments===''||map.comments===undefined){
    // that.$message.warning("驳回信息不能为空！");
    that.$message.warning(that.language['eletronicSigned.rejectCommentsNotNull'])
    return;
  }
  that.confirmLoading = true;
  postAction("/sys/electronic-signed/process/"+that.model.business_form_no, map).then((res) => {
    if (res.success) {
      that.setEdit = false;
      that.confirmLoading = false;
    }
  })
}
function other_returnTo(that,applicationCode,returnToCode){
  let map = {};
  map.applicationCode=applicationCode;
  map.processGuid = that.model.process_guid;
  map.taskCode = that.model.task_code;
  map.approverUserCode = that.$store.getters.userInfo.workNo;
  map.comments = that.model.comments;
  map.approveAction = "ReturnTo";
  map.returnToTaskCode = returnToCode
  map.fileList = that.model.filelist;
  if(map.comments===null||map.comments===''||map.comments===undefined){
    // that.$message.warning("驳回信息不能为空！");
    that.$message.warning(that.language['eletronicSigned.rejectCommentsNotNull'])
    return;
  }
  that.confirmLoading = true;
  postAction("/sys/electronic-signed/process/"+that.model.business_form_no, map).then((res) => {
    if (res.success) {
      that.setEdit = false;
      that.confirmLoading = false;
    }
  })
}
function cst_reject(that){
  if(that.processModel.modelCode === 'cst_check'){
    other_returnTo(that,"cst",'Applicant')
  }else if(that.processModel.modelCode === 'cst_interrupt_confirm'){
    other_returnTo(that,"cst",'Operator')
  }else if(that.processModel.modelCode === 'cst_interrupt_recovery'){
    other_returnTo(that,"cst",'FireResponsible')
  }else{
    other_reject(that,"cst");
  }
}
function epm_reject(that){
  let map = {};
  map.pfBpmProcessId = that.model.process_guid;
  map.comments = that.model.comments;
  map.workNo = that.$store.getters.userInfo.workNo;
  map.approveAction = "Reject";
  map.taskCode = that.model.task_code;
  if(map.comments===null||map.comments===''||map.comments===undefined){
    // that.$message.warning("驳回信息不能为空！");
    that.$message.warning(that.language['eletronicSigned.rejectCommentsNotNull'])
    return;
  }
  that.confirmLoading = true;
  getAction("/sys/wfapi/pageToRunProcess", map).then((res) => {
    if (res.success) {
      that.setEdit = false;
      that.confirmLoading = false;
    }
  })
}
function ipsys_reject(that) {
  if(that.model.model_code == 'IpsTrademarkUserReport'||that.model.model_code == 'IpsTrademarkUserReportC') {
    if(that.model.task_code==='ApproveTask8'){
      that.$message.warning(that.language['eletronicSigned.undertakerCannotReject'])
      return;
    }
    let map = {};
    map.processGuid = that.model.process_guid;
    map.taskCode = that.model.task_code;
    map.approverUserCode = that.$store.getters.userInfo.workNo;
    map.comments = that.model.comments;
    map.approveAction = "Reject";
    map.fileList = that.model.filelist;
    if(map.comments===null||map.comments===''||map.comments===undefined){
      // that.$message.warning("驳回信息不能为空！");
      that.$message.warning(that.language['eletronicSigned.rejectCommentsNotNull'])
      return;
    }
    that.confirmLoading = true;
    postAction("/sys/electronicSigned/ipsysProcess/"+that.model.process_guid, map).then((res) => {
      if (res.success) {
        that.setEdit = false;
        that.confirmLoading = false;
      }
    })
  }else{
    other_reject(that,"ipsys");
  }

}